import React from "react";
import { Button, Modal } from "react-bootstrap";
import Form from "../Components/Comman/Form";
import Joi from "joi-browser";
import auth from "../Services/authService";
import http from "../Services/httpService";
import config from "../config.json";
import Swal from "sweetalert2";
import { getAlert } from "../Services/appAlerts";

const SECURITY_POPUP_STYLES = {
  modalContent: {
    borderRadius: "0px",
    overflow: "hidden",
    border: "1px solid rgba(226, 232, 240, 1)",
    boxShadow: "0 24px 60px rgba(15, 23, 42, 0.16)",
  },
  modalDialog: {
    maxWidth: "800px",
  },
  modalHeader: {
    padding: "18px 22px",
    borderBottom: "1px solid #e2e8f0",
    background: "#ffffff",
  },
  headerContent: {
    width: "100%",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    gap: "14px",
  },
  modalFooter: {
    padding: "16px 22px 20px",
    borderTop: "1px solid rgba(226, 232, 240, 0.9)",
    background: "#ffffff"
  },
  titleWrap: {
    display: "flex",
    alignItems: "center",
    gap: "14px",
  },
  headerIcon: {
    width: "46px",
    height: "46px",
    borderRadius: "0px",
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    background: "#f1f5f9",
    color: "#0f172a",
    fontSize: "21px",
    boxShadow: "none",
  },
  title: {
    fontSize: "22px",
    fontWeight: 800,
    color: "#0f172a",
    lineHeight: 1.1,
    margin: 0,
  },
  subtitle: {
    fontSize: "12px",
    color: "#64748b",
    marginTop: "4px",
  },
  closeButton: {
    width: "38px",
    height: "38px",
    borderRadius: "0px",
    border: "1px solid rgba(226, 232, 240, 1)",
    background: "#ffffff",
    color: "#64748b",
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    fontSize: "16px",
    fontWeight: 800,
    boxShadow: "0 2px 6px rgba(15, 23, 42, 0.04)",
    cursor: "pointer",
    transition: "all 0.2s ease",
    flexShrink: 0,
  },
  modalBody: {
    padding: "20px 22px 22px 22px",
    background: "#ffffff",
  },
  helperCard: {
    borderRadius: "0px",
    padding: "16px",
    background: "#ffffff",
    border: "1px solid rgba(191, 219, 254, 0.9)",
    marginBottom: "16px",
  },
  helperTitle: {
    fontSize: "14px",
    fontWeight: 800,
    color: "#0f172a",
    marginBottom: "8px",
  },
  helperText: {
    fontSize: "12px",
    lineHeight: 1.7,
    color: "#64748b",
    margin: 0,
  },
  formCard: {
    borderRadius: "0px",
    border: "1px solid rgba(226, 232, 240, 1)",
    background: "#ffffff",
    boxShadow: "0 4px 12px rgba(15, 23, 42, 0.03)",
    padding: "20px",
  },
  footerActions: {
    display: "flex",
    justifyContent: "flex-end",
    gap: "10px",
    marginTop: "20px",
  },
  cancelButton: {
    display: "inline-flex",
    alignItems: "center",
    gap: "8px",
    borderRadius: "0px",
    border: "1px solid #cbd5e1",
    background: "#ffffff",
    color: "#334155",
    padding: "9px 18px",
    fontSize: "13px",
    fontWeight: 600,
    boxShadow: "0 2px 6px rgba(15, 23, 42, 0.04)",
    cursor: "pointer",
    transition: "all 0.2s ease",
  },
  saveButton: {
    display: "inline-flex",
    alignItems: "center",
    gap: "8px",
    borderRadius: "0px",
    border: "1px solid #2563eb",
    background: "#2563eb",
    color: "#ffffff",
    padding: "9px 18px",
    fontSize: "13px",
    fontWeight: 600,
    boxShadow: "0 2px 6px rgba(37, 99, 235, 0.2)",
    cursor: "pointer",
    transition: "all 0.2s ease",
  },
  saveButtonDisabled: {
    opacity: 0.55,
    boxShadow: "none",
  },
};

class ChangeSecurityQuestion extends Form {
  constructor(props) {
    super(props);
    this.state = {
      data: {},
      errors: {},
      securityQuestions1: [],
      securityQuestions2: [],
      securityQuestions3: [],
    };
  }

  async componentDidMount() {
    const { data: securityQuestions } = await http.get(
      config.GetCodemanager + "Security Question 1"
    );
    this.setState({
      securityQuestions1: securityQuestions,
      securityQuestions2: securityQuestions,
      securityQuestions3: securityQuestions,
    });
  }

  schema = {
    oldPassword: Joi.string().required().label("Password"),
    hintQuestion1: Joi.string().required().label("Security Question 1"),
    hintQuestion2: Joi.string().required().label("Security Question 2"),
    hintQuestion3: Joi.string().required().label("Security Question 3"),
    hintAnswer1: Joi.string().required().label("Answer 1"),
    hintAnswer2: Joi.string().required().label("Answer 2"),
    hintAnswer3: Joi.string().required().label("Answer 3"),
  };

  doSubmit = async () => {
    const { data } = this.state;
    const user = auth.getCurrentUser();
    data["id"] = user.id;
    data["newPassword"] = "";
    const { data: result } = await http.post(config.AddSecurityQuestion, data);
    if (result === "error") {
      getAlert("Password Incorrect", "", "error");
    } else {
      this.props.handleSecurityShowHide();
      getAlert("", "Saved Successfully", "success");
    }
  };

  render() {
    let { securityQuestions1, securityQuestions2, securityQuestions3, data } =
      this.state;
    const { securityShowHide, handleSecurityShowHide } = this.props;

    if (data["hintQuestion1"] !== undefined && data["hintQuestion1"] !== "") {
      securityQuestions2 = securityQuestions2.filter(
        (x) => x.id !== parseInt(data["hintQuestion1"])
      );
      securityQuestions3 = securityQuestions3.filter(
        (x) => x.id !== parseInt(data["hintQuestion1"])
      );
    }
    if (data["hintQuestion2"] !== undefined && data["hintQuestion2"] !== "") {
      securityQuestions1 = securityQuestions1.filter(
        (x) => x.id !== parseInt(data["hintQuestion2"])
      );
      securityQuestions3 = securityQuestions3.filter(
        (x) => x.id !== parseInt(data["hintQuestion2"])
      );
    }
    if (data["hintQuestion3"] !== undefined && data["hintQuestion3"] !== "") {
      securityQuestions1 = securityQuestions1.filter(
        (x) => x.id !== parseInt(data["hintQuestion3"])
      );
      securityQuestions2 = securityQuestions2.filter(
        (x) => x.id !== parseInt(data["hintQuestion3"])
      );
    }
    const isSaveDisabled = this.validate();

    return (
      <Modal
        show={securityShowHide}
        size="lg"
        centered
        onHide={handleSecurityShowHide}
        dialogClassName="security-popup-modal-dialog"
        contentClassName="security-popup-modal-content"
      >
        <style>
          {`
            .security-popup-modal-dialog {
              max-width: ${SECURITY_POPUP_STYLES.modalDialog.maxWidth};
            }
            .security-popup-modal-content,
            .security-popup-modal-dialog .modal-content {
              border-radius: 0px !important;
              overflow: ${SECURITY_POPUP_STYLES.modalContent.overflow};
              border: ${SECURITY_POPUP_STYLES.modalContent.border};
              box-shadow: ${SECURITY_POPUP_STYLES.modalContent.boxShadow};
            }
            .security-popup-modal-content .form-control {
              border-radius: 0px !important;
            }
          `}
        </style>

        <Modal.Header style={SECURITY_POPUP_STYLES.modalHeader}>
          <div style={SECURITY_POPUP_STYLES.headerContent}>
            <Modal.Title as="div" style={SECURITY_POPUP_STYLES.titleWrap}>
              <div style={SECURITY_POPUP_STYLES.headerIcon}>
                <i className="fa fa-shield" aria-hidden="true"></i>
              </div>
              <div>
                <div style={SECURITY_POPUP_STYLES.title}>Security Questions</div>
                <div style={SECURITY_POPUP_STYLES.subtitle}>
                  Update your security questions to keep your account safe.
                </div>
              </div>
            </Modal.Title>
            <button
              type="button"
              style={SECURITY_POPUP_STYLES.closeButton}
              onClick={handleSecurityShowHide}
              aria-label="Close security questions popup"
            >
              <i className="fa fa-times" aria-hidden="true"></i>
            </button>
          </div>
        </Modal.Header>

        <Modal.Body style={SECURITY_POPUP_STYLES.modalBody}>
          <div style={SECURITY_POPUP_STYLES.helperCard}>
            <div style={SECURITY_POPUP_STYLES.helperTitle}>Security guidance</div>
            <p style={SECURITY_POPUP_STYLES.helperText}>
              <i className="fa fa-info-circle mr-2"></i>
              Choose security questions that are easy for you to remember but hard for others to guess. These will be used for account recovery.
            </p>
          </div>

          <div style={SECURITY_POPUP_STYLES.formCard}>
            <div className="row">
              <div className="col-md-12">
                {this.renderInput("oldPassword", "Current Password", "password")}
              </div>
              <div className="col-md-12 mt-3 mb-2">
                <hr />
                <div style={{ fontSize: "14px", fontWeight: 700, color: "#475569" }}>Security Questions</div>
              </div>
              <div className="col-md-12">
                {this.renderSelect(
                  "hintQuestion1",
                  "Security Question 1",
                  securityQuestions1,
                  "name",
                  "id"
                )}
              </div>
              <div className="col-md-12">
                {this.renderInput("hintAnswer1", "Answer 1", "password")}
              </div>
              <div className="col-md-12">
                {this.renderSelect(
                  "hintQuestion2",
                  "Security Question 2",
                  securityQuestions2,
                  "name",
                  "id"
                )}
              </div>
              <div className="col-md-12">
                {this.renderInput("hintAnswer2", "Answer 2", "password")}
              </div>
              <div className="col-md-12">
                {this.renderSelect(
                  "hintQuestion3",
                  "Security Question 3",
                  securityQuestions3,
                  "name",
                  "id"
                )}
              </div>
              <div className="col-md-12">
                {this.renderInput("hintAnswer3", "Answer 3", "password")}
              </div>
            </div>
          </div>


        </Modal.Body>
        <Modal.Footer style={SECURITY_POPUP_STYLES.modalFooter}>
          <div style={SECURITY_POPUP_STYLES.footerActions}>
            <button
              type="button"
              style={SECURITY_POPUP_STYLES.cancelButton}
              onClick={handleSecurityShowHide}
            >
              <i className="fa fa-times" aria-hidden="true"></i>
              Cancel
            </button>
            <button
              type="button"
              style={{
                ...SECURITY_POPUP_STYLES.saveButton,
                ...(isSaveDisabled ? SECURITY_POPUP_STYLES.saveButtonDisabled : {}),
              }}
              disabled={isSaveDisabled}
              onClick={this.handleSubmit}
            >
              <i className="fa fa-check mr-2" aria-hidden="true"></i>
              Save Changes
            </button>
          </div>
        </Modal.Footer>
      </Modal>
    );
  }
}


export default ChangeSecurityQuestion;
